import axiosInstance from '@/shared/api/http';
import { API } from '@/shared/constants/api';
import ServiceBuilder from '@/shared/lib/utils/service';
export const reportUser = async (params) => ServiceBuilder.serviceRequest(async () => {
    const response = await axiosInstance.post(API.report, params);
    return response;
});
